// extracted by mini-css-extract-plugin
module.exports = {"section":"BrandsSection_section__PMp2Z","title":"BrandsSection_title__TTzH2","description":"BrandsSection_description__763hq","brandsWrapper":"BrandsSection_brandsWrapper__zPIcS"};